import React, { Component } from 'react'
import PopUp from '../round/PopUp'
import './game.css'
import '../round/round.css'
import BoundCoach from '../exam/BoundCoach'
import Triangle from '../round/Triangle'
import { get, post } from '../../ajax/tools'
import CheckboxIcoNot from '../../style/image/CheckboxIcoNot.png'
import CheckboxIcoHave from '../../style/image/CheckboxIcoHave.png'

class GGAddPopUp extends Component {
  constructor(props) {
    super(props)
    this.state = {
      IdNum: '', //用户id号
      BoundCoachId: '', //绑定辅导教师的ID
      BoundCoachIdNum: '', //绑定辅导教师的ID号

      MatchId: '',
      GGWindowId: '',
      IdtArr: [
        { id: 2, idt: '运动员' },
        { id: 3, idt: '辅导教师' },
        { id: 4, idt: '领队' },
      ], //身份
      IdtIsToggleOn: true,
      IdtBtn: 'false',
      IdtShow: '',
      IdtShowId: '',
      GroupArr: [], //组别
      GroupInfo: {}, //已选择组别信息
      GroupIsToggleOn: true,
      GroupBtn: 'false',
      GroupShow: '',
      ProjectArr: [], //项目总数据
      ProjectBrr: [], //已经选择的项目
      ProjectBrrNum: 0,
      ProjectMaxNum: null, //最多兼项数目
      UserInfo: {},
      BgMainHeight: document.documentElement.scrollTop,
      submitBtnStu: true,
      // pageStep: 1,
    }
  }

  UNSAFE_componentWillReceiveProps = (nextProps) => {
    const history = nextProps
    let UserInfo = history.UserInfo
    this.setState({
      IdNum: UserInfo.id,
      MatchId: history.MatchId,
      GGWindowId: history.GGWindowId,
    })
  }

  componentDidMount = function () {
    const history = this.props
    let UserInfoYYId = history.UserInfo.yy_num
    let UserInfo = history.UserInfo
    let MatchId = history.MatchId
    let GGWindowId = history.GGWindowId
    this.setState({
      IdNum: UserInfo.id,
      MatchId: MatchId,
      GGWindowId: GGWindowId,
    })
    get({ url: 'reuse/get_personal_info/' + UserInfoYYId }).then((res) => {
      if (res.errno === '200') {
        this.setState({
          UserInfo: res.data[0],
        })
      } else {
        this.setState({
          PopUp: '运动员信息错误',
          MessageTip: res.errmsg + '！',
        })
      }
    })
    get({ url: 'match/get_groups/' + MatchId }).then((res) => {
      if (res.errno === '200') {
        this.setState({
          GroupArr: res.data,
        })
      } else {
        this.setState({
          PopUp: '提示弹窗',
          MessageTip: res.errmsg + '！',
        })
      }
    })

    document.onclick = this.AllClick.bind(this) //下拉菜单监听隐藏
  }

  AllClick = () => {
    this.setState({
      IdtIsToggleOn: true,
      IdtBtn: 'false',
      GroupIsToggleOn: true,
      GroupBtn: 'false',
    })
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return
    }
  }

  //下拉菜单按钮
  ClickIdtDb(e) {
    e.nativeEvent.stopImmediatePropagation()
    this.setState((prevState) => ({
      IdtIsToggleOn: !prevState.IdtIsToggleOn,
      IdtBtn: prevState.IdtIsToggleOn ? 'true' : 'false',
      GroupIsToggleOn: true,
      GroupBtn: 'false',
    }))
  }
  ClickGroupDb(e) {
    e.nativeEvent.stopImmediatePropagation()
    this.setState((prevState) => ({
      GroupIsToggleOn: !prevState.GroupIsToggleOn,
      GroupBtn: prevState.GroupIsToggleOn ? 'true' : 'false',
      IdtIsToggleOn: true,
      IdtBtn: 'false',
    }))
  }

  //点击选择下拉菜单的内容
  ClickIdtArr = (item, index) => {
    this.setState({
      IdtIsToggleOn: true,
      IdtBtn: 'false',
      IdtShow: item.idt,
      IdtShowId: item.id,
      ProjectBrr: [],
      ProjectBrrNum: 0,
      GroupShow: '',
    })
  }
  ClickGroupArr = (item, index) => {
    // 年龄提示
    post({
      url: 'match/group_age_remind',
      data: {
        match_id: this.state.MatchId,
        group_id: item.group_id,
        user_id: this.state.UserInfo.id,
      },
    }).then((res) => {
      if (res.errno === '4105') {
        this.setState({
          PopUp: '提示弹窗',
          MessageTip: res.errmsg + '！',
        })
      }
    })
    this.setState({
      GroupIndex: index,
      GroupIsToggleOn: true,
      GroupBtn: 'false',
      GroupShow: item.name,
      GroupInfo: item,
      ProjectBrr: [],
      ProjectBrrNum: 0,
    })
    let MatchId = this.state.MatchId
    post({
      url: 'match/get_item',
      data: {
        match_id: MatchId,
        mag_id: item.mag_id,
      },
    }).then((res) => {
      if (res.errno === '200') {
        let ProjectTheArr = res.data
        for (let k = 0; k < ProjectTheArr.length; k++) {
          ProjectTheArr[k]['mag_id'] = item.mag_id
          ProjectTheArr[k]['MixingName'] =
            ProjectTheArr[k].name + '(' + item.name + ')'
        }
        this.setState({
          ProjectArr: ProjectTheArr,
          ProjectMaxNum: res.allow_item_num,
        })
      }
    })
  }
  //点击选择/取消选择项目
  ClickProjectArr = (item, index) => {
    let ProjectBrr = [...this.state.ProjectBrr]
    let ProjectMaxNum = this.state.ProjectMaxNum
    let GroupInfo = this.state.GroupInfo
    const existIndex = ProjectBrr.findIndex((p) => p.item_name === item.name)

    // 已选中则取消选择
    if (existIndex !== -1) {
      ProjectBrr.splice(existIndex, 1)
      ProjectBrr.forEach((p, i) => {
        p.Num = i + 1
      })
      this.setState({
        ProjectIndex: index,
        ProjectBrr: ProjectBrr,
        ProjectBrrNum: ProjectBrr.length,
      })
      return
    }

    let ProjectTrr = ProjectBrr.filter((p) => p.is_concurrent === 1)
    if (ProjectBrr.length === 0) {
      ProjectBrr.push({
        item_name: item.name,
        item_id: item.item_id,
        mag_id: GroupInfo.mag_id,
        mai_id: item.id,
        Num: 1,
        is_concurrent: item.is_concurrent,
      })
    } else if (ProjectTrr.length < ProjectMaxNum || item.is_concurrent !== 1) {
      ProjectBrr.push({
        item_name: item.name,
        item_id: item.item_id,
        mag_id: GroupInfo.mag_id,
        mai_id: item.id,
        Num: ProjectBrr.length + 1,
        is_concurrent: item.is_concurrent,
      })
    } else {
      this.setState({
        PopUp: '提示弹窗',
        MessageTip: '计入兼项科目数量已达到最多兼项限制',
      })
      return
    }
    this.setState({
      ProjectIndex: index,
      ProjectBrr: ProjectBrr,
      ProjectBrrNum: ProjectBrr.length,
    })
  }

  //按兼项限制计算可全选的项目列表
  getSelectableProjects = () => {
    const { ProjectArr, ProjectMaxNum, GroupInfo } = this.state
    let newBrr = []
    let concurrentCount = 0
    let limited = false
    for (let i = 0; i < ProjectArr.length; i++) {
      const item = ProjectArr[i]
      if (item.is_concurrent === 1) {
        if (ProjectMaxNum != null && concurrentCount >= ProjectMaxNum) {
          limited = true
          continue
        }
        concurrentCount++
      }
      newBrr.push({
        item_name: item.name,
        item_id: item.item_id,
        mag_id: GroupInfo.mag_id,
        mai_id: item.id,
        Num: newBrr.length + 1,
        is_concurrent: item.is_concurrent,
      })
    }
    return { list: newBrr, limited }
  }

  //是否已选满当前可全选项目
  isAllSelectableSelected = () => {
    const { list } = this.getSelectableProjects()
    const { ProjectBrr } = this.state
    if (list.length === 0 || ProjectBrr.length !== list.length) {
      return false
    }
    return list.every((item) =>
      ProjectBrr.some((p) => p.item_name === item.item_name)
    )
  }

  //全选 / 取消全选项目
  ClickProjectSelectAll = () => {
    const { ProjectArr } = this.state
    if (!ProjectArr || ProjectArr.length === 0) {
      return
    }

    if (this.isAllSelectableSelected()) {
      this.setState({
        ProjectBrr: [],
        ProjectBrrNum: 0,
      })
      return
    }

    const { list, limited } = this.getSelectableProjects()
    this.setState({
      ProjectBrr: list,
      ProjectBrrNum: list.length,
      ...(limited
        ? {
            PopUp: '提示弹窗',
            MessageTip: '计入兼项科目数量已达到最多兼项限制，部分项目未能全选',
          }
        : {}),
    })
  }

  isProjectSelected = (item) => {
    return this.state.ProjectBrr.some((p) => p.item_name === item.name)
  }

  //绑定辅导教师的返回逻辑处理
  BoundCoachBack(event) {
    this.setState({
      BoundCoachId: event.CoachId,
      BoundCoachIdNum: event.CoachIdNum,
    })
  }

  GGAddPopUpBtnOK() {
    let IdtShow = this.state.IdtShow
    let IdtShowId = this.state.IdtShowId
    let GroupShow = this.state.GroupShow
    let GroupInfo = this.state.GroupInfo
    let ProjectBrr = this.state.ProjectBrr
    let BoundCoachId = this.state.BoundCoachId
    let BoundCoachIdNum = this.state.BoundCoachIdNum
    let MatchId = this.state.MatchId
    let ProjectMaxNum = this.state.ProjectMaxNum
    let GGWindowId = this.state.GGWindowId
    if (this.state.submitBtnStu) {
      this.setState({
        submitBtnStu: false,
      })
      if (IdtShow !== '' && IdtShow === '运动员') {
        if (
          GroupShow !== '' &&
          ProjectBrr.length !== 0 &&
          BoundCoachIdNum !== ''
        ) {
          let UserInfo = this.state.UserInfo
          let UserId = UserInfo.id
          UserInfo['province'] = ''
          UserInfo['allow_item_num'] = ProjectMaxNum
          UserInfo['match_id'] = MatchId
          UserInfo['IdtShow'] = IdtShow
          UserInfo['identity'] = IdtShowId
          UserInfo['groups'] = GroupShow
          UserInfo['group_id'] = GroupInfo.group_id
          UserInfo['item'] = ProjectBrr
          UserInfo['coach_id'] = BoundCoachId
          UserInfo['coach_yy_num'] = BoundCoachIdNum
          UserInfo['team_id'] = GGWindowId
          UserInfo['user_id'] = UserId
          get({ url: 'user/basic_info' }).then((res) => {
            if (res.errno === '200') {
              let User = res.data[0]
              if (User.type === 1) {
                post({
                  url: 'match/match_enroll_team',
                  data: UserInfo,
                }).then((res) => {
                  this.setState({
                    submitBtnStu: true,
                  })
                  if (res.errno === '200') {
                    UserInfo['id'] = res.enroll_id
                    let ClickInfo = { BackType: 'OK', UserInfo: UserInfo }
                    this.props.GGAddPopUp(ClickInfo)
                  } else if (res.errno === '201') {
                    let ClickInfo = { BackType: 'OK', UserInfo: UserInfo }
                    this.props.GGAddPopUp(ClickInfo)
                  } else {
                    this.setState({
                      PopUp: '提示弹窗',
                      MessageTip: res.errmsg + '！',
                    })
                  }
                })
              } else if (User.type === 0) {
                this.setState({
                  PopUp: '账号被顶',
                  MessageTip: '当前设备已登录其他账户，请重新登录！',
                  submitBtnStu: true,
                })
              }
            } else {
              // sessionStorage.setItem('routesAddress','/match');
              // const {history} = this.props;
              // history.push('/login');
              window.location.href = '/login'
            }
          })
        } else {
          this.setState({
            PopUp: '提示弹窗',
            MessageTip: '您有必要的选项未选择！',
            submitBtnStu: true,
          })
        }
      } else if (IdtShow !== '' && IdtShow !== '运动员') {
        let UserInfo = this.state.UserInfo
        let UserId = UserInfo.id
        UserInfo['province'] = ''
        UserInfo['allow_item_num'] = ProjectMaxNum
        UserInfo['match_id'] = MatchId
        UserInfo['IdtShow'] = IdtShow
        UserInfo['identity'] = IdtShowId
        UserInfo['groups'] = GroupShow
        UserInfo['group_id'] = ''
        UserInfo['item'] = ProjectBrr
        UserInfo['coach_id'] = BoundCoachId
        UserInfo['coach_yy_num'] = BoundCoachIdNum
        UserInfo['team_id'] = GGWindowId
        UserInfo['user_id'] = UserId
        get({ url: 'user/basic_info' }).then((res) => {
          if (res.errno === '200') {
            let User = res.data[0]
            if (User.type === 1) {
              post({
                url: 'match/match_enroll_team',
                data: UserInfo,
              }).then((res) => {
                this.setState({
                  submitBtnStu: true,
                })
                if (res.errno === '200') {
                  UserInfo['id'] = res.enroll_id
                  let ClickInfo = { BackType: 'OK', UserInfo: UserInfo }
                  this.props.GGAddPopUp(ClickInfo)
                } else if (res.errno === '201') {
                  let ClickInfo = { BackType: 'OK', UserInfo: UserInfo }
                  this.props.GGAddPopUp(ClickInfo)
                  this.setState({
                    pageStep: 2,
                  })
                } else {
                  this.setState({
                    PopUp: '提示弹窗',
                    MessageTip: res.errmsg + '！',
                  })
                }
              })
            } else if (User.type === 0) {
              this.setState({
                PopUp: '账号被顶',
                MessageTip: '当前设备已登录其他账户，请重新登录！',
                submitBtnStu: true,
              })
            }
          } else {
            sessionStorage.setItem('routesAddress', '/match')
            const { history } = this.props
            history.push('/login')
          }
        })
      } else {
        this.setState({
          PopUp: '提示弹窗',
          MessageTip: '您有必要的选项未选择！',
          submitBtnStu: true,
        })
      }
    }
  }

  // 二次提交前确认
  // GGAddPopUpBtnOK() {
  //   let IdtShow = this.state.IdtShow
  //   let IdtShowId = this.state.IdtShowId
  //   let GroupShow = this.state.GroupShow
  //   let GroupInfo = this.state.GroupInfo
  //   let ProjectBrr = this.state.ProjectBrr
  //   let BoundCoachId = this.state.BoundCoachId
  //   let BoundCoachIdNum = this.state.BoundCoachIdNum
  //   let MatchId = this.state.MatchId
  //   let ProjectMaxNum = this.state.ProjectMaxNum
  //   let GGWindowId = this.state.GGWindowId
  //   let UserInfo = this.state.UserInfo
  //   let UserId = UserInfo.id

  //   // 校验参赛身份
  //   if (IdtShow === '') {
  //     this.setState({
  //       PopUp: '提示弹窗',
  //       MessageTip: '请选择参赛身份！',
  //     })
  //     return
  //   }

  //   // 保存基础信息到 UserInfo
  //   UserInfo['province'] = ''
  //   UserInfo['allow_item_num'] = ProjectMaxNum
  //   UserInfo['match_id'] = MatchId
  //   UserInfo['IdtShow'] = IdtShow
  //   UserInfo['identity'] = IdtShowId
  //   UserInfo['groups'] = GroupShow
  //   UserInfo['group_id'] = GroupInfo.group_id || ''
  //   UserInfo['item'] = ProjectBrr
  //   UserInfo['coach_id'] = BoundCoachId
  //   UserInfo['coach_yy_num'] = BoundCoachIdNum
  //   UserInfo['team_id'] = GGWindowId
  //   UserInfo['user_id'] = UserId

  //   // 运动员需要额外校验
  //   if (IdtShow === '运动员') {
  //     if (GroupShow === '') {
  //       this.setState({
  //         PopUp: '提示弹窗',
  //         MessageTip: '请选择参赛组别！',
  //       })
  //       return
  //     }
  //     if (ProjectBrr.length === 0) {
  //       this.setState({
  //         PopUp: '提示弹窗',
  //         MessageTip: '请选择参赛项目！',
  //       })
  //       return
  //     }
  //     if (BoundCoachIdNum === '') {
  //       this.setState({
  //         PopUp: '提示弹窗',
  //         MessageTip: '请绑定辅导教师！',
  //       })
  //       return
  //     }
  //   }

  //   // 跳转到确认页面
  //   this.setState({
  //     UserInfo: UserInfo,
  //     pageStep: 2,
  //   })
  // }

  GGAddPopUpBtnERR() {
    let ClickInfo = { BackType: 'ERR' }
    this.props.GGAddPopUp(ClickInfo)
  }

  // 二次确认添加
  // GGAddPopUpSubmitOK() {
  //   let UserInfo = this.state.UserInfo
  //   if (this.state.submitBtnStu) {
  //     this.setState({
  //       submitBtnStu: false,
  //     })
  //     get({ url: 'user/basic_info' }).then((res) => {
  //       if (res.errno === '200') {
  //         let User = res.data[0]
  //         if (User.type === 1) {
  //           post({
  //             url: 'match/match_enroll_team',
  //             data: UserInfo,
  //           }).then((res) => {
  //             this.setState({
  //               submitBtnStu: true,
  //             })
  //             if (res.errno === '200') {
  //               UserInfo['id'] = res.enroll_id
  //               let ClickInfo = { BackType: 'OK', UserInfo: UserInfo }
  //               this.props.GGAddPopUp(ClickInfo)
  //             } else if (res.errno === '201') {
  //               let ClickInfo = { BackType: 'OK', UserInfo: UserInfo }
  //               this.props.GGAddPopUp(ClickInfo)
  //             } else {
  //               this.setState({
  //                 PopUp: '提示弹窗',
  //                 MessageTip: res.errmsg + '！',
  //                 submitBtnStu: true,
  //                 pageStep: 1,
  //               })
  //             }
  //           })
  //         } else if (User.type === 0) {
  //           this.setState({
  //             PopUp: '账号被顶',
  //             MessageTip: '当前设备已登录其他账户，请重新登录！',
  //             submitBtnStu: true,
  //           })
  //         }
  //       } else {
  //         window.location.href = '/login'
  //       }
  //     })
  //   }
  // }

  // 添加人员弹窗页面操作后的返回
  GGAddPopUp = (event) => {
    if (event.BackType === 'OK') {
      let UserInfoAndItemList = this.state.UserInfoAndItem
      let MatchNum = this.state.MatchNum
      let UserInfoIdTest = []
      let UserInfoIdtTest = []
      for (let i = 0; i < UserInfoAndItemList.length; i++) {
        const YYNumList = UserInfoAndItemList[i].yy_num
        UserInfoIdTest.push(YYNumList)
        const IdtShowList = UserInfoAndItemList[i].IdtShow
        if (IdtShowList === '运动员') {
          UserInfoIdtTest.push(IdtShowList)
        }
      }
      if (event.UserInfo.IdtShow === '运动员') {
        if (UserInfoIdtTest.length < MatchNum) {
          if (UserInfoIdTest.includes(event.UserInfo.yy_num)) {
            this.setState({
              GameGroupAdd: '',
              PopUp: '提示弹窗',
              MessageTip: '您已经添加过该成员，请不要重复添加！',
            })
          } else {
            UserInfoAndItemList.push(event.UserInfo)
            this.setState(
              {
                GameGroupAdd: '',
                UserInfoAndItem: UserInfoAndItemList,
              },
              () => {
                if (this.ggItemRef.current) {
                  this.ggItemRef.current.refreshData()
                }
                if (this.ggSignInfoRef.current) {
                  this.ggSignInfoRef.current.refreshData(
                    this.state.UserInfoAndItem
                  )
                }
              }
            )
          }
        } else {
          this.setState({
            PopUp: '指示弹窗',
            MessageTip: '运动员已达上限，请增加新参赛队！',
          })
        }
      } else {
        if (UserInfoIdTest.includes(event.UserInfo.yy_num)) {
          this.setState({
            GameGroupAdd: '',
            PopUp: '提示弹窗',
            MessageTip: '您已经添加过该成员，请不要重复添加！',
          })
        } else {
          UserInfoAndItemList.push(event.UserInfo)
          this.setState(
            {
              GameGroupAdd: '',
              UserInfoAndItem: UserInfoAndItemList,
            },
            () => {
              if (this.ggItemRef.current) {
                this.ggItemRef.current.refreshData()
              }
              if (this.ggSignInfoRef.current) {
                this.ggSignInfoRef.current.refreshData(
                  this.state.UserInfoAndItem
                )
              }
            }
          )
        }
      }
    } else if (event.BackType === 'ERR') {
      this.setState({
        GameGroupAdd: '',
      })
    }
  }

  // 二次确认添加后取消
  // GGAddPopUpSubmitErr() {
  //   this.setState({
  //     pageStep: 1,
  //   })
  // }

  //提示弹窗
  ChildBackTip = (event) => {
    if (event === 'CrossOut') {
      this.setState({
        PopUp: '',
      })
    }
  }
  //提示弹窗
  ErrBackTip = (event) => {
    if (event === 'CrossOut') {
      this.setState({
        PopUp: '',
      })
      let ClickInfo = { BackType: 'ERR' }
      this.props.GGAddPopUp(ClickInfo)
    }
  }

  AccountNext = (event) => {
    if (event === 'CrossOut') {
      window.location.reload()
    } else if (event === 'Confirm') {
      window.location.reload()
    }
  }

  render() {
    const isAthlete = this.state.IdtShow === '运动员' // 是否为运动员

    return (
      <div>
        <div className={'PopUpBoxBg'}> </div>

        <div
          className={'GGAddPopUpBgBox'}
          style={{ top: this.state.BgMainHeight + 2 }}
        >
          <div className={'GGAddPopBorder'} style={{ marginTop: 60 }}>
            <div className={'GGAddPopTitleBox'} style={{ marginTop: 6 }}>
              添加人员信息
            </div>
            <div
              className={'GGAddPopMainBox clearfix'}
              style={{ marginTop: 2, marginBottom: 5 }}
            >
              <div className={'GGAPInfoBox'}>
                <div className={'GGAPInfoPhoto'}>
                  <img alt={''} src={this.state.UserInfo.image} />
                </div>
                <div className={'GGAPInfoListBox clearfix'}>
                  <div className={'GGAPInfoListTit'}>姓名：</div>
                  <div className={'GGAPInfoListCon'}>
                    {this.state.UserInfo.real_name}
                  </div>
                </div>
                <div className={'GGAPInfoListBox clearfix'}>
                  <div className={'GGAPInfoListTit'}>ID：</div>
                  <div className={'GGAPInfoListCon'}>
                    {this.state.UserInfo.yy_num}
                  </div>
                </div>
              </div>
              <div className={'GGAPSelectBox'}>
                <ul
                  className={'GPClickUlBox clearfix'}
                  style={{ marginTop: 40 }}
                >
                  <li className={'GPClickLiBox'}>
                    <div className={'GPClickInfoTit'}>*参赛身份</div>
                    <div className={'GPClickInfoCon'}>
                      <div
                        className={'GPDownBtn'}
                        onClick={this.ClickIdtDb.bind(this)}
                      >
                        <Triangle
                          Direction={'down'}
                          Color={'#FFFFFF'}
                          Width={'7px'}
                          Height={'10px'}
                          Top={'10px'}
                          Right={'23px'}
                        />
                      </div>
                      <div className={'GPSelectShow'}>
                        {this.state.IdtShow === ''
                          ? '请选择参赛身份'
                          : this.state.IdtShow}
                      </div>
                      {this.state.IdtBtn === 'true' && (
                        <div className={'GPSelect'}>
                          {this.state.IdtArr.map((item, index) => (
                            <div
                              className={'GPOption'}
                              key={index}
                              onClick={() => this.ClickIdtArr(item, index)}
                            >
                              {item.idt}
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  </li>
                  {/* 只有运动员才显示参赛组别和参赛项目 */}
                  {isAthlete && (
                    <div>
                      <li className={'GPClickLiBox'}>
                        <div className={'GPClickInfoTit'}>*参赛组别</div>
                        <div className={'GPClickInfoCon'}>
                          <div
                            className={'GPDownBtn'}
                            onClick={this.ClickGroupDb.bind(this)}
                          >
                            <Triangle
                              Direction={'down'}
                              Color={'#FFFFFF'}
                              Width={'7px'}
                              Height={'10px'}
                              Top={'10px'}
                              Right={'23px'}
                            />
                          </div>
                          <div className={'GPSelectShow'}>
                            {this.state.GroupShow === ''
                              ? '请选择参赛组别'
                              : this.state.GroupShow}
                          </div>
                          {this.state.GroupBtn === 'true' && (
                            <div className={'GPSelect'}>
                              {this.state.GroupArr.map((item, index) => (
                                <div
                                  className={'GPOption'}
                                  key={index}
                                  onClick={() =>
                                    this.ClickGroupArr(item, index)
                                  }
                                >
                                  {item.name}
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </li>
                      <li className={'GPClickLiBox clearfix'}>
                        <div className={'GPClickInfoTit'}>*参赛项目</div>
                        <div className={'GPClickInfoCon'}>
                          <div className={'GPProjectListBox'}>
                            <div className={'GPProjectListHeader'}>
                              <div
                                className={'GPProjectSelectAllBtn'}
                                onClick={this.ClickProjectSelectAll}
                              >
                                {this.isAllSelectableSelected()
                                  ? '取消全选'
                                  : '全选'}
                              </div>
                              <div className={'GPProjectSelectedCount'}>
                                已选择{this.state.ProjectBrrNum}个项目
                              </div>
                            </div>
                            <div className={'GPProjectListScroll'}>
                              {this.state.ProjectArr.length === 0 ? (
                                <div className={'GPProjectListEmpty'}>
                                  请先选择参赛组别
                                </div>
                              ) : (
                                this.state.ProjectArr.map((item, index) => {
                                  const selected = this.isProjectSelected(item)
                                  return (
                                    <div
                                      className={
                                        'GPProjectListItem' +
                                        (selected ? ' selected' : '')
                                      }
                                      key={index}
                                      title={item.name}
                                      onClick={() =>
                                        this.ClickProjectArr(item, index)
                                      }
                                    >
                                      <span
                                        className={'GPProjectListCheckbox'}
                                        style={{
                                          backgroundImage: selected
                                            ? 'url(' + CheckboxIcoHave + ')'
                                            : 'url(' + CheckboxIcoNot + ')',
                                        }}
                                      />
                                      <span className={'GPProjectListName'}>
                                        {item.name}
                                      </span>
                                    </div>
                                  )
                                })
                              )}
                            </div>
                          </div>
                        </div>
                      </li>
                    </div>
                  )}
                </ul>
                {/* 只有运动员才显示绑定辅导教师 */}
                {isAthlete && (
                  <BoundCoach
                    BoundCoachBack={this.BoundCoachBack.bind(this)}
                    IdNum={this.state.IdNum}
                    BoundCoachIdNum={this.state.BoundCoachIdNum}
                  />
                )}
              </div>
            </div>
          </div>
          <div className={'GGAddPopUpBtnBox clearfix'}>
            <div
              className={'GGAddPopUpBtnOK'}
              onClick={this.GGAddPopUpBtnOK.bind(this)}
              style={{
                pointerEvents: this.state.submitBtnStu ? 'auto' : 'none',
              }}
            >
              确定
            </div>
            <div
              className={'GGAddPopUpBtnERR'}
              onClick={this.GGAddPopUpBtnERR.bind(this)}
            >
              取消
            </div>
          </div>
        </div>

        {/* {this.state.pageStep === 2 && (
          <div
            className={'GGAddPopUpBgBox'}
            style={{ top: this.state.BgMainHeight + 2 }}
          >
            <div className={'GGAddPopBorder'} style={{ marginTop: 60 }}>
              <div className={'GGAddPopTitleBox'} style={{ marginTop: 6 }}>
                确认参赛人员信息
              </div>
        
              <div className={'GGConfirmInfoBox'}>
                <div className={'GGConfirmItem'}>
                  <div className={'GGConfirmLabel'}>姓名：</div>
                  <div className={'GGConfirmValue'}>
                    {this.state.UserInfo.real_name}
                  </div>
                </div>
                <div className={'GGConfirmItem'}>
                  <div className={'GGConfirmLabel'}>ID：</div>
                  <div className={'GGConfirmValue'}>
                    {this.state.UserInfo.yy_num}
                  </div>
                </div>
                <div className={'GGConfirmItem'}>
                  <div className={'GGConfirmLabel'}>参赛身份：</div>
                  <div className={'GGConfirmValue'}>{this.state.IdtShow}</div>
                </div>
                {isAthlete && (
                  <>
                    <div className={'GGConfirmItem'}>
                      <div className={'GGConfirmLabel'}>参赛组别：</div>
                      <div className={'GGConfirmValue'}>
                        {this.state.GroupShow}
                      </div>
                    </div>
                    <div className={'GGConfirmItem'}>
                      <div className={'GGConfirmLabel'}>参赛项目：</div>
                      <div className={'GGConfirmValue GGConfirmProjectList'}>
                        {this.state.ProjectBrr.length > 0 ? (
                          <div className={'GGProjectList'}>
                            {this.state.ProjectBrr.map((item, index) => (
                              <div className={'GGProjectItem'} key={index}>
                                <span className={'GGProjectIndex'}>
                                  {item.Num}.
                                </span>
                                <span className={'GGProjectName'}>
                                  {item.item_name}
                                </span>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <span className={'GGConfirmEmpty'}>未选择项目</span>
                        )}
                      </div>
                    </div>
                  </>
                )}
              </div>
            </div>

            <div className={'GGAddPopUpBtnBox clearfix'}>
              <div
                className={'GGAddPopUpBtnOK'}
                onClick={this.GGAddPopUpSubmitOK.bind(this)}
                style={{
                  pointerEvents: this.state.submitBtnStu ? 'auto' : 'none',
                }}
              >
                提交
              </div>
              <div
                className={'GGAddPopUpBtnERR'}
                onClick={this.GGAddPopUpSubmitErr.bind(this)}
              >
                取消
              </div>
            </div>
          </div>
        )} */}

        {this.state.PopUp === '提示弹窗' && (
          <PopUp
            ChildBackClick={this.ChildBackTip.bind(this)}
            type={'提示'}
            message={this.state.MessageTip}
            OutButton={'Yes'}
          />
        )}
        {this.state.PopUp === '运动员信息错误' && (
          <PopUp
            ChildBackClick={this.ErrBackTip.bind(this)}
            type={'提示'}
            message={this.state.MessageTip}
            OutButton={'Yes'}
          />
        )}
        {this.state.PopUp === '账号被顶' && (
          <PopUp
            ChildBackClick={this.AccountNext.bind(this)}
            type={'失败'}
            message={this.state.MessageTip}
            OutButton={'No'}
          />
        )}
      </div>
    )
  }
}

export default GGAddPopUp
